<template>
  <div>
    <div>
      <HomeVue v-if="view == 'home' && $store.getters.get_company.id == 1" />
      
      <MaintenanceVue @setView="setView" v-if="view == 'mantenimiento'" />

      <CloseBeadVue @setView="setView" v-if="view == 'close_bead' && $store.getters.get_company.id == 1" />
      <CloseBeadAqVue @setView="setView" v-if="view == 'close_bead' && $store.getters.get_company.id == 3" />
      
      <ProccessVue v-if="view == 'proccess'" @mtdViewFooter="mtdViewFooter" @setView="setView" />
      <ReportView v-if="view == 'reports'" @mtdViewFooter="mtdViewFooter" @setView="setView" />
    </div>
    <FooterVue v-if="view == 'home'" :view="view" @setView="setView" />
  </div>
</template>

<script>
import FooterVue from "../../components/administrador/demo/Footer.vue";
import HomeVue from "../../components/administrador/demo/Home.vue";
import MaintenanceVue from "../../views/maintenance/index.vue";
import CloseBeadVue from "../../components/caja/demo/page/CloseBead.vue";
import CloseBeadAqVue from "../../components/caja/aq/page/CloseBead.vue";
import ProccessVue from '../proccess/ProccessView.vue';
import ReportView from '../reports/ReportsView.vue';


export default {
  components: { FooterVue, HomeVue, MaintenanceVue, CloseBeadVue, ProccessVue, ReportView,CloseBeadAqVue },
  data() {
    return {
      view: "home",
      booFooter: true
    };
  },
  methods: {
    setView: function (payload) {
      this.view = payload;
    },
    mtdViewFooter: function (boo, view) {
      this.booFooter = boo;
      if (boo == true) this.view = view;
    }
  },
};
</script>

<style lang="scss" scoped></style>
